import { apiRequest } from './api';

// ── Types ───────────────────────────────────────────────────

export type FeeType = 'tuition' | 'transport' | 'hostel' | 'other';

export const FEE_TYPE_OPTIONS: { value: FeeType; label: string }[] = [
    { value: 'tuition', label: 'Tuition' },
    { value: 'transport', label: 'Transport' },
    { value: 'hostel', label: 'Hostel' },
    { value: 'other', label: 'Other' },
];

export type FeeFrequency = 'monthly' | 'quarterly' | 'half_yearly' | 'annual' | 'one_time';

export const FEE_FREQUENCY_OPTIONS: { value: FeeFrequency; label: string }[] = [
    { value: 'monthly', label: 'Monthly' },
    { value: 'quarterly', label: 'Quarterly' },
    { value: 'half_yearly', label: 'Half-Yearly' },
    { value: 'annual', label: 'Annual' },
    { value: 'one_time', label: 'One Time' },
];

export const MONTH_OPTIONS: { value: number; label: string }[] = [
    { value: 1, label: 'January' },
    { value: 2, label: 'February' },
    { value: 3, label: 'March' },
    { value: 4, label: 'April' },
    { value: 5, label: 'May' },
    { value: 6, label: 'June' },
    { value: 7, label: 'July' },
    { value: 8, label: 'August' },
    { value: 9, label: 'September' },
    { value: 10, label: 'October' },
    { value: 11, label: 'November' },
    { value: 12, label: 'December' },
];

export type FeeHeadPayload = {
    name: string;
    type?: FeeType;
    frequency?: FeeFrequency;
    // Preferred billing month (1–12); relevant for non-monthly frequencies.
    billing_month?: number | null;
    is_optional?: boolean;
};

export type FeeHeadRecord = {
    id: string;
    organization_id: string;
    name: string;
    type: FeeType | null;
    frequency: FeeFrequency | null;
    billing_month: number | null;
    is_optional: boolean;
    created_at: string;
    updated_at: string;
};

// ── API Functions ───────────────────────────────────────────

export async function fetchFeeHeadsApi(): Promise<FeeHeadRecord[]> {
    const res = await apiRequest<FeeHeadRecord[]>('/api/fee-heads');
    return res.data;
}

export async function createFeeHead(payload: FeeHeadPayload): Promise<FeeHeadRecord> {
    const res = await apiRequest<FeeHeadRecord>('/api/fee-heads', {
        method: 'POST',
        body: JSON.stringify(payload),
    });
    return res.data;
}
